<template>
  <!-- 在线考试页面 -->
  <section class="container">
    <Header @loadPage="onload"></Header>
    <div class="wrapper">
      <div class="locationM text-left">
        <Breadcrumb>
          <img class="img" src="../assets/location.png" alt />
          当前位置：
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem>在线考试</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <div class="innerM">
        <div class="title">在线考试</div>
        <div class="courseM" v-if="$store.state.isLogin && isAlert == 1">
          <div class="col-20 course" v-for="(exam, index) in examList" :key="index">
            <div class="cover inner relative">
              <img class="img" src="../assets/online.png" alt />
              <div class="brief relative pointer">
                <div class="b-wrapper">
                  <div class="text-center paper">
                    <img src="../assets/paper.png" alt />
                  </div>
                  <div class="text-center exam-title">{{coursetitle(exam.examTitle)}}</div>
                </div>
                <div class="status">
                  <div>考试时间</div>
                  <div>{{exam.startTime}}-{{exam.endTime}}</div>
                  <div>合格标准：{{exam.passScore}}分</div>
                  <div class="text-center">
                    <button class="btn pointer" :data-id="exam.examId" @click="examClick">去考试</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal v-model="paymodel" width="360" :mask-closable="false">
          <p slot="header" class="model-header">
            <Icon type="logo-yen" />
            <span>请使用微信扫描二维码进行支付</span>
          </p>
          <div class="model-content" style="text-align:center">
            <p>二维码</p>
            <img :src="codeimg" alt />
          </div>
          <div slot="footer">
            <Button type="text" @click="paymodel = false">取消</Button>
            <Button type="success" @click="payCompletd">确认支付</Button>
          </div>
        </Modal>
        <div style="display: none">
          <video class="video" id="video" width="240" height="180" autoplay></video>
        </div>
        <Alert class="alert" type="warning" v-if="$store.state.isLogin && isAlert == -1" show-icon>
          您目前没有考试信息，如有考试信息，考试系统将在考前半小时开放。
          <template
            slot="desc"
          >You currently have no exam information, and the exam information will be displayed half an hour before the exam.</template>
        </Alert>
        <Alert class="alert" type="error" v-if="!$store.state.isLogin" show-icon>
          您需要登录后才能查看该内容
          <span slot="desc">You need to be logged in to view this content.</span>
        </Alert>
      </div>
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
export default {
  name: "Online",
  data() {
    return {
      isAlert: "", //-1代表无考试，1代表有考试
      paymodel: false,
      takePhoto: true, //是否需要检测摄像头工作
      codeimg: "", //支付二维码
      distanceStartTime: 0,
      timeout: "", //定时器
      examList: []
    };
  },
  mounted() {
    var that = this;

    that.onload();
    this.setTab();
  },
  watch: {
    distanceStartTime: function(newQuestion, oldQuestion) {
      var that = this;
      if (newQuestion > 0) {
        that.timeout = window.setTimeout(function() {
          newQuestion--;
          that.distanceStartTime = newQuestion;
        }, 1000 * 60);
        //去掉定时器的方法
      } else {
        window.clearTimeout(that.timeout);
      }
    }
  },
  methods: {
    onload() {
      //初始化
      var that = this;
      var token = that.$cookie.get("xjaf-token");
      var username = that.$cookie.get("xjaf-user");
      if (token != null && username != null) {
        this.httprequest();
      } else {
        this.$store.commit("login");
      }
    },
    httprequest() {
      var that = this;
      var modelData = {
        page: "1",
        size: "10"
      };
      this.$http({
        url: that.webhost + "exam/list",
        method: "POST",
        data: modelData
      }).then(({ data }) => {
        if (data && data.code === 0) {
          that.examList = data.data;
          if (that.examList.length > 0) {
            that.isAlert = 1;
            that.exam = data.data[0];
            that.examinfo();
            that.distanceStartTime = data.data[0].distanceStartTime;
          } else {
            that.isAlert = -1;
          }
        } else {
          that.$Message.error(data.msg);
          that.isAlert = -1;
        }
      });
    },
    examinfo() {
      var that = this;
      var exam = that.exam;
      var takePhoto = that.takePhoto;
      if (exam.takePhoto && exam.takePhoto === 1 && takePhoto) {
        that.checkVideo();
      } else if (exam.orderNumber && exam.orderNumber != "") {
        // that.checkPay();
      }
    },
    checkVideo() {
      // 检测摄像头
      var that = this;
      var exam = that.exam;
      that.$Modal.info({
        title: "远程考试须知",
        content:
          "远程考试需要配合摄像头考试，需要获取权限，即将弹出www.xjafpx.com使用您的摄像头，请点击允许。否则不能正常考试。",
        onOk: () => {
          that.openVideo(exam);
        }
      });
    },
    checkPay() {
      // 检测是否需要缴交补考
      var that = this;
      var exam = that.exam;
      var modelData = {
        orderNumber: exam.orderNumber,
        totalFee: exam.totalFee,
        tradeType: "NATIVE"
      };
      that
        .$http({
          url: that.webhost + "wechat/pay/nativePay",
          method: "POST",
          data: modelData
        })
        .then(({ data }) => {
          if (data && data.code === 0) {
            that.$Modal.info({
              title: "补考须知",
              content:
                "目前检测您当前为补考学员，需要缴纳" +
                exam.totalFee +
                "元补考费，才能进行考试。请您接下去使用微信支付进行缴纳，确保考试能正常进行。",
              onOk: () => {
                that.paymodel = true;
                that.codeimg =
                  that.webhost +
                  "wechat/pay/createScanPayQrcodeMode?codeUrl=" +
                  data.data.codeUrl;
              }
            });
          } else if (data && data.code === 1001) {
            exam.orderNumber = null;
            that.exam = exam;
          } else {
            that.$Message.error(data.msg);
          }
        });
    },
    openVideo(exam) {
      var that = this;
      // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
          // 首先，如果有getUserMedia的话，就获得它
          var getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia;

          // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
          if (!getUserMedia) {
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }

          // 否则，为老的navigator.getUserMedia方法包裹一个Promise
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      //调用摄像头的主体部分
      var constraints = {
        video: true,
        audio: false
      };
      var promise = navigator.mediaDevices.getUserMedia(constraints);
      promise
        .then(function(stream) {
          //成功调用后回调函数
          var aVideo = $("#video")[0];
          try {
            aVideo.srcObject = stream;
          } catch (error) {
            aVideo.src = URL.createObjectURL(stream);
          }
          aVideo.onerror = function() {
            stream.stop();
          };
          aVideo.onloadedmetadata = function() {
            var msg =
              "摄像头设备检测到可以正常使用，请保持此状态，确保考试作答可以正常进行.";
            that.$Message.success({
              content: msg,
              duration: 5
            });
            that.takePhoto = false;
            exam.takePhoto = 0;
            that.examinfo(exam);
          };
        })
        .catch(function(err) {
          //调用失败后的回调函数---需要做对应的处理
          var msg = "";
          that.takePhoto = true;
          switch (err.name) {
            case "NotAllowedError":
              msg = "请在浏览器相关设置里允许该网页使用摄像头.";
              break;
            case "AbortError":
              msg =
                "摄像被阻止使用,假如您的操作没有不当的地方.建议换一台设备进行操作";
              break;
            case "NotFoundError":
              msg = "没有找到摄像头设备。建议换一台设备进行操作";
              break;
            case "NotReadableError":
              msg =
                "虽然您已授予使用匹配设备的权限，但操作系统，浏览器或网页级别发生硬件错误，导致无法访问设备。建议换一台设备进行操作。";
              break;
            case "OverconstrainedError":
              msg =
                "指定的约束导致没有符合所请求标准的候选设备。建议换一台设备进行操作";
              break;
            case "SecurityError":
              msg = "该摄像头对象禁用用户媒体支持,建议换一台设备进行操作";
              break;
            case "TypeError":
              msg = "指定的约束列表为空,请联系技术人员.";
              break;
          }
          console.log(err);

          that.$Message.error({
            content: msg,
            duration: 5
          });
        });
    },
    payCompletd() {
      var that = this;
      that.paymodel = false;
      that.$Modal.info({
        title: "支付须知",
        content: "支付到账情况有延迟，建议您刷新页面后重新查看。",
        okText: "刷新页面",
        onOk: () => {
          that.$router.go(0);
        }
      });
    },
    examClick(e) {
      var that = this;
      console.log("去考试");
      var exam = that.exam;
      var takePhoto = that.takePhoto;
      if (exam.takePhoto && exam.takePhoto === 1 && takePhoto) {
        that.checkVideo();
      }
      // else if (exam.orderNumber && exam.orderNumber != "") {
      // that.checkPay();
      // }
      else if (that.distanceStartTime > 0) {
        that.$Modal.info({
          title: "还未到考试时间",
          content:
            "距离考试开始还有" +
            that.distanceStartTime +
            "分钟,请在" +
            that.distanceStartTime +
            "分钟后重新进行操作！"
        });
      } else {
        that.$router.push("/Examination/" + e.currentTarget.dataset.id);
      }
    },
    viewClick(e) {
      var i = +e.currentTarget.dataset.id;
      var j = +e.currentTarget.dataset.id2;
      var course = this.courseList[i].contentList[j];
      this.$store.commit("setCourse", course);
      this.$router.push(`/Course?subjectCode=${this.$store.state.subjectCode}`);
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>

<style scoped>
.wrapper {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 90px;
  font-family: "PingFang SC";
}
.innerM {
  margin-top: 20px;
  min-height: 500px;
}
.title {
  text-align: left;
  font-size: 25px;
  line-height: 72px;
  color: #000;
  border-bottom: solid 2px #ccc;
}
.locationM {
  height: 50px;
  line-height: 50px;
}
.locationM .ivu-breadcrumb {
  font-size: 15px;
  color: #000;
}
.locationM img {
  width: 23px;
  height: 22px;
  margin-right: 5px;
  position: relative;
  top: 3px;
}
.courseM {
  width: 100%;
  text-align: left;
  margin-top: 20px;
}
.course {
  display: inline-block;
  width: 20%;
  margin-bottom: 30px;
}
.course .inner {
  width: 95%;
  margin: auto;
}
.course .cover .img {
  width: 228px;
  height: 283px;
}
.course .brief {
  position: absolute;
  left: 0;
  top: 0;
  width: 228px;
  height: 283px;
  color: #fff;
}
.course .brief .status {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px 5px;
  background: rgba(125, 125, 125, 0.79);
}
.course .brief .status .text-center {
  margin-top: 10px;
}
.course .brief .status .btn {
  width: 90px;
  background: #fff;
  color: #000;
  height: 28px;
  line-height: 28px;
  border: none;
  outline: none;
}
.course .brief .status .btn:hover {
  color: #23b8ff;
  opacity: 0.9;
}
.course .brief .status .btn:active {
  color: #23b8ff;
  opacity: 1;
}
.brief .b-wrapper {
  height: 170px;
}
.brief .b-wrapper .paper {
  height: 120px;
  position: relative;
  text-align: center;
  padding-top: 50px;
}
.brief .b-wrapper .paper img {
  width: 50px;
}
.brief .b-wrapper .exam-title {
  width: 90%;
  margin: auto;
  font-size: 14px;
}
.model-header {
  color: #00b5ff;
  text-align: center;
}
.model-content {
  text-align: center;
}
.model-content img {
  display: block;
  width: 300px;
  height: 300px;
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Online.vue